import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyAJWyYbzLFvfTrTYSlOhsMaAhAw7o-p1aE',
  authDomain: 'odaka-app.firebaseapp.com',
  databaseURL: 'https://odaka-app.firebaseio.com',
  projectId: 'odaka-app',
  storageBucket: "odaka-app.appspot.com",
  messagingSenderId: '944048446893',
  appId: '1:944048446893:web:2bbc62a81538d9cf'
}
firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
export default firebase



// WEBPACK FOOTER //
// ./src/firebase/firebase.js